import React from 'react';
import { V3 } from '../api_request';
import Article from '../discovery/article';
import RelatedArticles from '../shared/related_articles';
import URLHelpers from '../shared/url_helpers';

const RRelatedArticles = RelatedArticles as any;

interface Props {
  slugs: string[];
  heading?: string;
}

interface State {
  articles: Article[];
}

export default class ArticleGridEmbed extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    const req = V3.get(URLHelpers.articlesMultiplePath(), { slugs: this.props.slugs });

    req.then((response) => {
      this.setState({ articles: response.articles });
    });
  }

  render() {
    return (
      <RRelatedArticles
        heading={this.props.heading}
        articles={this.state.articles}
      />
    );
  }
}
